module.exports = __webpack_public_path__ + "img/w3_circle_trash_recover_light.313fb3cb.png";